import React from "react";
import DefaultLayout from "../layouts/Default";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import styled from "styled-components";
import Slider from "../utils/Slider";
import Image from "../utils/Image";
import TitleCar from "../utils/TitleCar";
import CardPopUp from "../utils/CardPopUp";
import { ButtonPdf } from "../utils/ButtonCAR";
import LinkGeneral from "../utils/LinkGeneral";

const images = require.context("../../assets/img/", true);

const Grid2 = styled.div`
  display: grid;
  margin-top: 2rem;
  grid-template-columns: 48% 48%;
  column-gap: 4%;
  row-gap: 2rem;
`;

const MainBanner = () => {
  const sliders = [
    { imageURL: "./banner1.png" },
    { imageURL: "./banner1.png" },
  ];

  return (
    <Slider
      data={sliders.map((item, index) => (
        <Image
          key={index}
          src={images(item.imageURL)}
          alt={`Banner #${index + 1} de la pagina web`}
          classNameDiv="p-0"
          classNameImg="w-100"
        ></Image>
      ))}
      id="slider-banner"
      classItems="w-100"
    />
  );
};

const ProyectosEstandarizados = () => (
  <div className="px-3 py-3">
    <h5>PROYECTOS ESTANDARIZADOS</h5>
    <p>
      A partir de la estrategia de estandarización de proyectos del CONPES 3856
      del 2016, el cual identifican e integran actividades, tareas,
      procedimientos y diseños comunes, con atributos especializados y
      estándares mínimos de calidad, operación, dotación y servicio. Como
      resultado de este proceso se conforman prototipos que cumplen con las
      mejores especificaciones y que pueden ser replicados al contar con los
      aspectos básicos para su implementación, como diseños, planos, presupuesto
      y cronogramas de ejecución, entre otros.
    </p>
    <p>
      En concordancia con lo anterior, la Corporación Autónoma Regional de
      Cundinamarca – CAR realizó la adaptación de dicha estrategia, con el
      objeto de generar proyectos estandarizados en materia ambiental y se busca
      agilizar la tarea de las entidades territoriales en la jurisdicción de la
      Corporación para realizar la formulación y estructuración de proyectos que
      pueden ser cofinanciados por la CAR.
    </p>
    <Image
      src={images("./Proyectos_estandarizados.png")}
      classNameDiv="d-flex justify-content-center"
    ></Image>
    <h5 className="py-3">Tipos de proyectos Estandarizados</h5>
    <div className="py-4">
      <CardPopUp
        description={
          <h5>
            1. Construcción de sistemas de almacenamiento de agua lluvia para la
            disponibilidad hídrica en los municipios de la jurisdicción CAR.
          </h5>
        }
        iconSrc={"./logo_car_corto.svg"}
      >
        <div
          style={{
            maxWidth: "1000px",
            maxHeight: "700px",
            overflow: "scroll",
          }}
        >
          <p>
            Este proyecto estandarizado cuyo propósito consiste en involucrar
            prácticas de aprovechamiento de agua lluvia mediante sistemas de
            recolección y almacenamiento del recurso en temporadas con destino a
            uso agropecuario en época seca/estiaje en predios donde se
            desarrollen este tipo de actividad económica. Lo anterior, contempla
            asesoría técnica y acompañamiento social enfocada a las buenas
            prácticas y uso adecuado del recurso hídrico.
          </p>
          <p>
            A continuación, podrá descargar la documentación asociada a este
            proyecto estandarizado:
          </p>
          <LinkGeneral> -Documento guía.</LinkGeneral>
          <br />
          <LinkGeneral> - Modelo ficha FormulaCAR.</LinkGeneral>
          <br />
          <LinkGeneral> - Presupuesto.</LinkGeneral>
          <br />
          <LinkGeneral> - Cronograma.</LinkGeneral>
          <br />
          <LinkGeneral>
            - Anexos técnicos (diseños, desarrollo técnico de la alternativa,
            etc).
          </LinkGeneral>
          <br />
          <LinkGeneral>
            - Otros anexos (ficha de caracterización de beneficiarios,
            encuestas, cartas de autorización y compromiso, etc.).
          </LinkGeneral>
        </div>
      </CardPopUp>
    </div>
    <div className="py-4">
      <CardPopUp
        description={
          <h5>
            2. Instalación de biodigestores para la generación de energía
            calórica (cocción de alimentos) en hogares rurales dispersos en un
            municipio de la jurisdicción CAR.
          </h5>
        }
        iconSrc={"./logo_car_corto.svg"}
      >
        <div
          style={{
            maxWidth: "1000px",
            maxHeight: "700px",
            overflow: "scroll",
          }}
        >
          <p>
            Este proyecto estandarizado consiste en promover la implementación
            de una tecnología para la generación de energía calórica,
            específicamente biogás a partir de biomasa residual orgánica. Lo
            anterior, a través de una digestión anaeróbica y por acción
            bacteriana ocurre la degradación de la materia orgánica, dando como
            productos el biogás y el biol (un biofertilizante líquido).
          </p>
          <p>
            A continuación, podrá descargar la documentación asociada a este
            proyecto estandarizado:
          </p>
          <LinkGeneral> -Documento guía.</LinkGeneral>
          <br />
          <LinkGeneral> - Modelo ficha FormulaCAR.</LinkGeneral>
          <br />
          <LinkGeneral> - Presupuesto.</LinkGeneral>
          <br />
          <LinkGeneral> - Cronograma.</LinkGeneral>
          <br />
          <LinkGeneral>
            - Anexos técnicos (diseños, desarrollo técnico de la alternativa,
            etc).
          </LinkGeneral>
          <br />
          <LinkGeneral>
            - Otros anexos (ficha de caracterización de beneficiarios,
            encuestas, cartas de autorización y compromiso, etc.).
          </LinkGeneral>
        </div>
      </CardPopUp>
    </div>
  </div>
);

const TiposProyectos = () => {
  return (
    <DefaultLayout>
      {/* <MainBanner /> */}
      <div className="row justify-content-center ">
        <div className="row col-11 col-lg-9 my-4">
          <div className="col-12 py-3">
            <TitleCar>
              <b>Tipos de proyectos</b>
            </TitleCar>
            <div className="pt-5 pb-3 fs-responsive-m">
              <p>
                <b>Proyecto: </b>El conjunto de actividades y acciones que
                requieren la utilización de recursos financieros para satisfacer
                una necesidad o solucionar un problema de la comunidad. Dentro
                de esta argumentación es importante obtener una precisión acerca
                de los impactos de los mismos, con la pretensión de optimizar
                nuevas actuaciones en materia ambiental.
              </p>
            </div>
            <div className="border py-3">
              <ButtonPdf
                className="border p-4"
                title="proyectos de inversión pública.pdf"
                href="http://bproyectos.car.gov.co/guias%20y%20procedimientos/proyectos%20de%20inversion%20publica.pdf"
              >
                Consultelo aquí
              </ButtonPdf>
            </div>
            <h5 className="py-3">Tipos de proyectos:</h5>

            <Tabs className="border-end border-start border-bottom rounded-3 ">
              <TabList>
                <Tab>1. PROYECTOS INTERNOS</Tab>
                <Tab>2. PROYECTOS ESTANDARIZADOS</Tab>
                <Tab>3. PROYECTOS DE COFINANCIACION</Tab>
              </TabList>

              <TabPanel>
                <div className="px-3 py-3">
                  <h5>PROYECTOS INTERNOS</h5>
                  <p>
                    Los proyectos internos son aquellos que se realizan al
                    interior de la Corporación Autónoma Regional de Cundinamarca
                    en cumplimiento de los programas del PA y PGAR, y son
                    formulados desde las áreas técnicas.
                  </p>
                </div>
              </TabPanel>
              <TabPanel>
                <ProyectosEstandarizados />
              </TabPanel>
              <TabPanel>
                <div className="px-3 py-3">
                  <h5>PROYECTOS DE COFINANCIACION</h5>
                  <p>
                    Se entienden como los proyectos y/o iniciativas de inversión
                    propuestas por entidades externas y que se articulan al PA y
                    PGAR, para ser financiados con recursos de la Corporación
                    Autónoma Regional de Cundinamarca CAR en el marco del
                    Acuerdo 26 de 2021.
                  </p>
                  <Grid2>
                    <div className=" py-3">
                      <ButtonPdf
                        title="Acuerdo 26 de 2021.pdf"
                        href="http://bproyectos.car.gov.co/guias%20y%20procedimientos/proyectos%20de%20inversion%20publica.pdf"
                      >
                        Consultelo aquí
                      </ButtonPdf>
                    </div>
                    <div className=" py-3">
                      <ButtonPdf
                        title="Resolución 20227000152 del 8 de abril de 2022.pdf"
                        href="http://bproyectos.car.gov.co/guias%20y%20procedimientos/proyectos%20de%20inversion%20publica.pdf"
                      >
                        Consultelo aquí
                      </ButtonPdf>
                    </div>
                  </Grid2>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default TiposProyectos;
